import { createContext, ReactNode, useState } from 'react';
import { LayoutContextValue, LayoutType, setLayoutProp } from '@contexts/layout/layout.type';

export const LayoutContext = createContext<LayoutContextValue>({
  layoutType: undefined,
  setLayout: () => {},
});

export const LayoutProvider = ({ children }: { children: ReactNode }) => {
  const [layoutType, setLayoutType] = useState<LayoutType>();
  const [topElementNode, setTopElementNode] = useState<ReactNode>();
  const [bottomElementNode, setBottomElementNode] = useState<ReactNode>();
  const setLayout = ({ type, topElement, bottomElement }: setLayoutProp) => {
    setLayoutType(type);
    setTopElementNode(topElement);
    setBottomElementNode(bottomElement);
  };
  return (
    <LayoutContext.Provider
      value={{
        layoutType,
        setLayout,
      }}>
      {!!topElementNode && topElementNode}
      {children}
      {!!bottomElementNode && bottomElementNode}
    </LayoutContext.Provider>
  );
};
